import React, { Suspense } from 'react';
import { useRoutes } from 'react-router-dom';

// components
import Root from './Root';
import PrivateRoute from './PrivateRoute';
import Dashboard from '../crm/other/account/Dashboard';
import Settings from '../crm/other/account/Settings';


// lazy load all the views
// auth
const Login = React.lazy(() => import('../crm/auth/Login'));
const SignUp = React.lazy(() => import('../crm/auth/SignUp'));
const FreeTrial = React.lazy(() => import('../crm/auth/FreeTrial'));
const ForgetPassword = React.lazy(() => import('../crm/auth/ForgetPassword'));
const Confirm = React.lazy(() => import('../crm/auth/Confirm'));
const Logout = React.lazy(() => import('../crm/auth/Logout'));
const CheckOut = React.lazy(() => import('../crm/auth/CheckOut'));
const Payment = React.lazy(() => import('../crm/auth/Payment'));
const ReviewDetails = React.lazy(() => import('../crm/auth/ReviewDetails'));
const TermsCondition = React.lazy(() => import('../crm/auth/TermsCondition'))


// home
const Home = React.lazy(() => import('../crm/Home'));

// landings
const App = React.lazy(() => import('../crm/landings/App'));
const Saas = React.lazy(() => import('../crm/landings/Saas/Saas'));
const Saas2 = React.lazy(() => import('../crm/landings/Saas/Saas2'));
const Startup = React.lazy(() => import('../crm/landings/Startup'));
const Software = React.lazy(() => import('../crm/landings/Software'));

const Agency = React.lazy(() => import('../crm/landings/Agency'));
const Coworking = React.lazy(() => import('../crm/landings/Coworking'));
const Crypto = React.lazy(() => import('../crm/landings/Crypto'));
const Marketing = React.lazy(() => import('../crm/landings/Marketing'));
const Portfolio = React.lazy(() => import('../crm/landings/Portfolio'));
// pages

//crm
const Dashboardd = React.lazy(() => import('../crm/other/account/Dashboard'));
const Settingss = React.lazy(() => import('../crm/other/account/Settings'));

const Blogg = React.lazy(() => import('../crm/other/Blog'));
const BlogPostt = React.lazy(() => import('../crm/other/BlogPost'));

const Companyy = React.lazy(() => import('../crm/other/Company'));
const Contactt = React.lazy(() => import('../crm/other/Contact'));
const Contentt = React.lazy(() => import('../crm/other/content'));
const Careerr = React.lazy(() => import('../crm/other/Career'));
const Pricingg = React.lazy(() => import('../crm/other/Pricing'));

const PortfolioGridd = React.lazy(() => import('../crm/other/portfolio/PortfolioGrid'));
const PortfolioMasonryy = React.lazy(() => import('../crm/other/portfolio/PortfolioMasonry'));
const PortfolioItemm = React.lazy(() => import('../crm/other/portfolio/PortfolioItem'));

const HelpDeskk = React.lazy(() => import('../crm/other/HelpDesk'));

// docs
const Introduction = React.lazy(() => import('../crm/docs/Introduction'));
const QuickStart = React.lazy(() => import('../crm/docs/QuickStart'));
const Customization = React.lazy(() => import('../crm/docs/Customization'));
const Routing = React.lazy(() => import('../crm/docs/Routing'));
const CodeSpliting = React.lazy(() => import('../crm/docs/CodeSpliting'));
const ChangeLog = React.lazy(() => import('../crm/docs/ChangeLog'));

const Colors = React.lazy(() => import('../crm/docs/Colors'));
const Typography = React.lazy(() => import('../crm/docs/Typography'));

const Bootstrap = React.lazy(() => import('../crm/docs/Bootstrap'));
const Custom = React.lazy(() => import('../crm/docs/Custom'));
const Plugins = React.lazy(() => import('../crm/docs/Plugins'));

const Navbars = React.lazy(() => import('../crm/docs/Navbars'));
const Heros = React.lazy(() => import('../crm/docs/Heros'));

const loading = () => <div className=""></div>;

type LoadComponentProps = {
    component: React.LazyExoticComponent<() => JSX.Element>;
};

const LoadComponent = ({ component: Component }: LoadComponentProps) => (
    <Suspense fallback={loading()}>
        <Component />
    </Suspense>
);

const AllRoutes = () => {
    return useRoutes([
        {
            // root route
            path: '/',
            element: <Root />,
        },
        {
            // public routes
            path: '/',
            children: [
                {
                    path: 'auth',
                    children: [
                        { path: 'login', element: <LoadComponent component={Login} /> },
                        { path: 'signup', element: <LoadComponent component={SignUp} /> },
                        { path: 'freeTrial', element: <LoadComponent component={FreeTrial} /> },
                        { path: 'checkOut', element: <LoadComponent component={CheckOut} /> },
                        { path: 'payment', element: <LoadComponent component={Payment} /> },
                        { path: 'termsCondition', element: <LoadComponent component={TermsCondition} /> },
                        { path: 'reviewDetails', element: <LoadComponent component={ReviewDetails} /> },
                        { path: 'forget-password', element: <LoadComponent component={ForgetPassword} /> },
                        { path: 'confirm', element: <LoadComponent component={Confirm} /> },
                        { path: 'logout', element: <LoadComponent component={Logout} /> },
                    ],
                },
                {
                    path: 'docs',
                    children: [
                        { path: 'introduction', element: <LoadComponent component={Introduction} /> },
                        { path: 'quick-start', element: <LoadComponent component={QuickStart} /> },
                        { path: 'customization', element: <LoadComponent component={Customization} /> },
                        { path: 'routing', element: <LoadComponent component={Routing} /> },
                        { path: 'code-spliting', element: <LoadComponent component={CodeSpliting} /> },
                        { path: 'change-log', element: <LoadComponent component={ChangeLog} /> },

                        { path: 'colors', element: <LoadComponent component={Colors} /> },
                        { path: 'typography', element: <LoadComponent component={Typography} /> },
                        { path: 'bootstrap', element: <LoadComponent component={Bootstrap} /> },
                        { path: 'custom', element: <LoadComponent component={Custom} /> },
                        { path: 'plugins', element: <LoadComponent component={Plugins} /> },
                        { path: 'navbars', element: <LoadComponent component={Navbars} /> },
                        { path: 'heros', element: <LoadComponent component={Heros} /> },
                    ],
                },
                {
                    // path: 'home',
                    index: true,
                    element: <LoadComponent component={App} />,
                },
                {
                    path: 'landing',
                    children: [
                        { path: 'app', element: <LoadComponent component={App} /> },
                        { path: 'saas', element: <LoadComponent component={Saas} /> },
                        { path: 'saas2', element: <LoadComponent component={Saas2} /> },
                        { path: 'startup', element: <LoadComponent component={Startup} /> },
                        { path: 'software', element: <LoadComponent component={Software} /> },

                        { path: 'agency', element: <LoadComponent component={Agency} /> },
                        { path: 'coworking', element: <LoadComponent component={Coworking} /> },
                        { path: 'crypto', element: <LoadComponent component={Crypto} /> },
                        { path: 'marketing', element: <LoadComponent component={Marketing} /> },
                        { path: 'portfolio', element: <LoadComponent component={Portfolio} /> },
                    ],
                },
                {
                    path: 'blogs',
                    children: [
                        { path: '', element: <LoadComponent component={Blogg} /> },
                        { path: ':title', element: <LoadComponent component={BlogPostt} /> },
                    ],
                },
                {
                    path: 'crm',
                    children: [
                        // {
                        //     path: 'blog',
                        //     children: [
                        //         { path: '', element: <LoadComponent component={Blogg} /> },
                        //         { path: ':title', element: <LoadComponent component={BlogPostt} /> },
                        //     ],
                        // },
                        { path: 'about', element: <LoadComponent component={Companyy} /> },
                        { path: 'contact', element: <LoadComponent component={Contactt} /> },
                        { path: 'content', element: <LoadComponent component={Contentt} /> },
                        { path: 'career', element: <LoadComponent component={Careerr} /> },
                        { path: 'pricing', element: <LoadComponent component={Pricingg} /> },
                        { path: 'feature', element: <LoadComponent component={PortfolioItemm} /> },
                        {
                            path: 'portfolio',
                            children: [
                                { path: 'grid', element: <LoadComponent component={PortfolioGridd} /> },
                                { path: 'masonry', element: <LoadComponent component={PortfolioMasonryy} /> },
                                { path: 'item', element: <LoadComponent component={PortfolioItemm} /> },
                            ],
                        },
                        { path: 'help', element: <LoadComponent component={HelpDeskk} /> },
                    ]
                },
            ],
        },
        {
            // protected routes
            path: '/',
            element: <PrivateRoute roles={'Admin'} />,
            children: [
                {
                    path: 'pages',
                    children: [
                        {
                            path: 'account',
                            children: [
                                // { path: 'dashboard', element: <LoadComponent component={Dashboard} /> },
                                // { path: 'settings', element: <LoadComponent component={Settings} /> },
                            ],
                        },
                    ],
                },
            ],
        },
    ]);
};

export default AllRoutes;
